// removed by extract-text-webpack-plugin
module.exports = {"container":"inbox__container___2OzVW","bottom-grid":"inbox__bottom-grid___1-pjV","top-grid":"inbox__top-grid___2vLZG","gl-grid":"inbox__gl-grid___3DvyA","gl-panel":"inbox__gl-panel___3ojWi"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/inbox.scss
// module id = 1328
// module chunks = 0